export enum roles {
    company_admin = "company-admin", // Access to company admin
}